import api from "./api";
import axios from "axios";

class SottoprogettoPianoDiFatturazioneManager {
    pianoDiFatturazione(sottoprogetto_id: number | string, pdf_id: number | string, config?: any) {
        return api.get(`/sottoprogetti/${sottoprogetto_id}/piano_di_fatturazione/${pdf_id}`, config)
    }

    createPianoDiFatturazione(sottoprogetto_id: number | string, data: any) {
        return api.post(`/sottoprogetti/${sottoprogetto_id}/piano_di_fatturazione`, data)
    }

    updatePianoDiFatturazione(sottoprogetto_id: number | string, pdf_id: number | string, data: any) {
        return api.put(`/sottoprogetti/${sottoprogetto_id}/piano_di_fatturazione/${pdf_id}/`, data)
    }

    deletePianoDiFatturazione(sottoprogetto_id: number | string, pdf_id: number | string,) {
        return api.delete(`/sottoprogetti/${sottoprogetto_id}/piano_di_fatturazione/${pdf_id}/`)
    }

    cambiaStatoPianoDiFatturazione(sottoprogetto_id: number | string, pdf_id: number | string, data:any) {
        return api.patch(`/sottoprogetti/${sottoprogetto_id}/piano_di_fatturazione/${pdf_id}/cambia_stato/`, data)
    }

    retrieve = this.pianoDiFatturazione

}

const sottoprogettoPianoDiFatturazioneManager = new SottoprogettoPianoDiFatturazioneManager()

export default sottoprogettoPianoDiFatturazioneManager

